module.exports = __webpack_public_path__ + "img/epay-zy.79d10be5.png";